import styled from "styled-components";

export const Header = styled.header`
  background-color: rgba(255, 255, 255, 0.94);

  @supports (backdrop-filter: blur(12px)) {
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px) saturate(1.4);
    -webkit-backdrop-filter: blur(12px) saturate(1.4);
  }

  border-bottom: 1px solid ${({ theme: { colors } }) => colors.slate[200]};
  padding: 14px 0;

  position: sticky;
  top: 0;
  left: 0;
  right: 0;

  z-index: 9999;
`;

export const Container = styled.div``;

export const Wtapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuListWrapper = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  padding-left: 0;
`;

export const MenuItem = styled.li`
  position: relative;

  a {
    display: inline-block;
    padding: 10px 14px;
    border-radius: ${({ theme: { radii } }) => radii.sm};
    font-family: ${({ theme: { font } }) => font.heading};
    font-size: ${({ theme: { font } }) => font.main};
    font-weight: 500;
    letter-spacing: 0.01em;
    color: ${({ active, theme: { colors } }) =>
      active ? colors.main.red : colors.slate[700]};

    transition: color ${({ theme: { transition } }) => transition.fast},
      background-color ${({ theme: { transition } }) => transition.fast};

    &::after {
      content: "";
      position: absolute;
      left: 14px;
      right: 14px;
      bottom: 2px;
      height: 2px;
      border-radius: 2px;
      background-color: ${({ theme: { colors } }) => colors.main.red};
      transform: scaleX(${({ active }) => (active ? 1 : 0)});
      transform-origin: left center;
      transition: transform ${({ theme: { transition } }) => transition.base};
    }

    &:hover {
      color: ${({ active, theme: { colors } }) =>
        active ? colors.main.red : colors.navy[700]};
      background-color: ${({ theme: { colors } }) => colors.navy[50]};
    }
  }

  &.cta {
    margin-left: 12px;

    a {
      padding: 0;

      &::after {
        content: none;
      }

      &:hover {
        background-color: transparent;
      }
    }
  }
`;

export const MobileMenuContainer = styled.div``;

export const MobileMenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 44px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${({ theme: { colors } }) => colors.slate[200]};
  border-radius: ${({ theme: { radii } }) => radii.sm};
  color: ${({ theme: { colors } }) => colors.navy[800]};

  transition: background-color ${({ theme: { transition } }) => transition.fast},
    border-color ${({ theme: { transition } }) => transition.fast};

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.navy[50]};
    border-color: ${({ theme: { colors } }) => colors.slate[300]};
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;
